<div class="header"> {{reference.title}}
  <h3 mat-dialog-title class="title" [ngClass]="{ error: reference.isError }">{{ reference.title || reference.translate.title | translate }} {{ reference.lastTitle }}</h3>
  <button *ngIf="!reference?.translate.isDelete" mat-icon-button class="cancel" (click)="closeDialog('close')">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
    <ng-container *ngIf="data?.type =='alter', else other">
      <p>{{ data.message | translate }}</p>
    </ng-container>

</mat-dialog-content>
<mat-dialog-actions align="end">
      <button cdkFocusInitial mat-flat-button color="warn" (click)="closeDialog('cancel')">{{ reference.translate.negative || 'LABEL.CANCEL' | translate }}</button>
      <button mat-flat-button color="accent" (click)="_handleClose()" [mat-dialog-close]="true">{{ reference.translate.postive || 'LABEL.OK' | translate }}</button>
</mat-dialog-actions>

<ng-template #other>
  <p *ngFor="let desc of reference.descriptions">{{ desc }}</p>
  <p *ngFor="let text of reference.translate.descriptions">{{ text | translate }}</p>
</ng-template>
